import React, { useEffect, useState } from 'react';
import { Modal, Button, Form, Row, Col } from 'react-bootstrap';
import Select from 'react-select';
import { customStyles, DropdownIndicator } from '~/Styles/reactSelectStyles';
import { toast } from 'react-toastify';
import * as api from '~/Services/Service';
import { SUBETAPAS_OPTIONS, MOTIVOS_REPROVACAO, formatCpfCnpj } from './constants';
import { FaSpinner } from 'react-icons/fa';
import { podeReenviarAnalise } from '~/Pages/SolicitacoesCessoes/solicitacoesCessaoListaHelpers';

const SUBETAPA_EM_ANDAMENTO = 1;

const ModalStatusDoc = ({ show, onHide, solicitacao, onSuccess }) => {
  const [status, setStatus] = useState(null);
  const [motivo, setMotivo] = useState('');
  const [observacao, setObservacao] = useState('');
  const [enviarEmail, setEnviarEmail] = useState(true);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const reenvio = podeReenviarAnalise(solicitacao);
  const opcoesStatus = reenvio
    ? SUBETAPAS_OPTIONS.filter(opt => opt.value === SUBETAPA_EM_ANDAMENTO)
    : SUBETAPAS_OPTIONS;

  useEffect(() => {
    if (show && solicitacao) {
      setStatus(
        podeReenviarAnalise(solicitacao)
          ? SUBETAPA_EM_ANDAMENTO
          : solicitacao.codigo_sub_etapa || null
      );
      setMotivo('');
      setObservacao('');
      setEnviarEmail(true);
    }
  }, [show, solicitacao]);

  useEffect(() => {
    if (status === 2 || status === 3) {
      setEnviarEmail(true);
    }
  }, [status]);

  const handleSave = async () => {
    if (!solicitacao) return;

    if (status === 3 && !motivo) {
      toast.error('Selecione o motivo da reprovação');
      return;
    }

    if ((status === 2 || status === 3) && !observacao.trim()) {
      toast.error('Preencha a observação');
      return;
    }

    setIsSubmitting(true);
    try {
      if (reenvio) {
        await api.reenviarAnaliseCessao({
          codigo_solicitacao: solicitacao.codigo,
          observacao: observacao.trim() || null,
        });
        toast.success('Solicitação reenviada para análise!');
        onHide();
        if (onSuccess) onSuccess();
        return;
      }

      const motivoEncontrado = MOTIVOS_REPROVACAO.find(m => m.value === motivo);
      const obsCompleta =
        status === 3
          ? `Motivo: ${
              motivoEncontrado ? motivoEncontrado.label : motivo
            }. ${observacao}`
          : observacao;

      await api.alterarStatusCessao({
        codigo_solicitacao: solicitacao.codigo,
        codigo_etapa: solicitacao.codigo_etapa,
        codigo_sub_etapa: status,
        observacao: obsCompleta,
        enviar_email: enviarEmail,
      });

      toast.success('Status alterado com sucesso!');
      onHide();
      if (onSuccess) onSuccess();
    } catch (err) {
      toast.error((err && err.message) || 'Erro ao alterar status');
    } finally {
      setIsSubmitting(false);
    }
  };

  const selectedStatusOption = SUBETAPAS_OPTIONS.find(opt => opt.value === status);
  const selectedMotivoOption = MOTIVOS_REPROVACAO.find(
    opt => opt.value === motivo
  );

  return (
    <Modal show={show} onHide={onHide} centered size="lg" backdrop="static">
      <Modal.Header closeButton>
        <Modal.Title>Alterar Status da Documentação</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {solicitacao && (
          <div className="mb-3 p-2 bg-light rounded">
            <small className="text-muted">
              <strong>Solicitação #{solicitacao.codigo}</strong> |{' '}
              {solicitacao.nome_solicitante} | {solicitacao.empreendimento} - Qd{' '}
              {solicitacao.quadra} Lt {solicitacao.lote}
            </small>
          </div>
        )}
        <Row>
          <Col md={12} className="mb-3">
            <Form.Group>
              <Form.Label>Novo Status</Form.Label>
              <Select
                options={opcoesStatus}
                value={selectedStatusOption}
                onChange={opt => setStatus(opt ? opt.value : null)}
                styles={{
                  ...customStyles,
                  menuPortal: base => ({ ...base, zIndex: 9999 }),
                }}
                components={{ DropdownIndicator }}
                placeholder="Selecione o novo status..."
                menuPortalTarget={document.body}
                isDisabled={isSubmitting}
              />
            </Form.Group>
          </Col>

          {status === 3 && (
            <Col md={12} className="mb-3">
              <Form.Group>
                <Form.Label>
                  Motivo da Reprovação <span className="text-danger">*</span>
                </Form.Label>
                <Select
                  options={MOTIVOS_REPROVACAO}
                  value={selectedMotivoOption}
                  onChange={opt => setMotivo(opt ? opt.value : '')}
                  styles={{
                    ...customStyles,
                    menuPortal: base => ({ ...base, zIndex: 9999 }),
                  }}
                  components={{ DropdownIndicator }}
                  placeholder="Selecione o motivo..."
                  menuPortalTarget={document.body}
                  isDisabled={isSubmitting}
                />
              </Form.Group>
            </Col>
          )}

          <Col md={12} className="mb-3">
            <Form.Group>
              <Form.Label>
                Observação{' '}
                {(status === 2 || status === 3) && (
                  <span className="text-danger">*</span>
                )}
              </Form.Label>
              <Form.Control
                as="textarea"
                rows={3}
                value={observacao}
                onChange={e => setObservacao(e.target.value)}
                placeholder="Insira uma observação..."
                disabled={isSubmitting}
              />
            </Form.Group>
          </Col>

          {reenvio && (
            <Col md={12} className="mb-3">
              <small className="text-muted">
                A solicitação está{' '}
                {solicitacao.codigo_sub_etapa === 5 ? 'bloqueada' : 'reprovada'}{' '}
                e será reenviada para análise de documentos.
              </small>
            </Col>
          )}

          <Col md={12} hidden={reenvio}>
            <div className="d-flex justify-content-between align-items-center bg-light p-3 rounded border">
              <Form.Check
                type="checkbox"
                id="check-email"
                label="Enviar e-mail ao cliente com a atualização"
                checked={enviarEmail}
                onChange={e => setEnviarEmail(e.target.checked)}
                disabled={isSubmitting}
              />
            </div>
            {status === 5 && (
              <small className="text-danger mt-1 d-block">
                * O cliente não poderá realizar alterações enquanto estiver
                bloqueado.
              </small>
            )}
          </Col>
        </Row>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide} disabled={isSubmitting}>
          Cancelar
        </Button>
        <Button
          variant="success"
          onClick={handleSave}
          disabled={isSubmitting || !status}
        >
          {isSubmitting ? (
            <>
              <FaSpinner className="fa-spin mr-2" />
              Salvando...
            </>
          ) : (
            'Salvar Alterações'
          )}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ModalStatusDoc;
